import styled from 'styled-components';

export default styled.div`
  && {
    .title {
      background-color: rgba(193, 225, 141, 1);
      height: 70px;
      padding: 25px 40px;
      display: flex;
      justify-content: space-between;
      .icon-billing {
        margin-top: 5px;
        margin-right: 10px;
        font-size: 20px;
      }
      .inline {
        display: inline-block;
      }
    }
  }
`;
